import React from "react";
import { useTranslation } from "react-i18next";
import { unavailability as unavailabilityMock } from "@planzone/dto";
import {
  useAuthentication,
  useUnavailabilityCreation,
  useRetrieveUnavailabilityReasons,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { UnavailabilityCreationForm } from "./unavailabilityCreationForm";
import { Loader } from "@common/loader";

import { Props } from "./types";
import styles from "./styles.scss";

function UnavailabilityCreation({ cancel }: Props) {
  const { t } = useTranslation();
  const { account } = useAuthentication();
  const [formData, setFormData] = React.useState({
    ...unavailabilityMock,
    resource: account.resource,
  });
  const { error, isRequestPending, createUnavailability } =
    useUnavailabilityCreation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending: isUnavailabilityReasonsRequestPending,
    isRequestSuccess: isUnavailabilityReasonsRequestSuccess,
    isRequestFailure: isUnavailabilityReasonsRequestFailure,
    unavailabilityReasons,
    retrieveUnavailabilityReasons,
  } = useRetrieveUnavailabilityReasons();
  const loading = isUnavailabilityReasonsRequestPending;

  React.useEffect(() => {
    !isUnavailabilityReasonsRequestPending &&
      !isUnavailabilityReasonsRequestSuccess &&
      !isUnavailabilityReasonsRequestFailure &&
      retrieveUnavailabilityReasons();
  }, [
    isUnavailabilityReasonsRequestPending,
    isUnavailabilityReasonsRequestSuccess,
    isUnavailabilityReasonsRequestFailure,
  ]);

  React.useEffect(() => {
    isUnavailabilityReasonsRequestSuccess &&
      setFormData((data) => ({ ...data, reason: unavailabilityReasons[0] }));
  }, [unavailabilityReasons]);

  return (
    <Modal header={t("unavailability.creation.title")} close={cancel}>
      <form
        onSubmit={(event) => {
          event.preventDefault();

          !isRequestPending &&
            createUnavailability({
              unavailability: {
                ...formData,
                endDate: formData.endDate || formData.startDate,
              },
              planzone,
            });
        }}
        className={styles.unavailabilityCreation}
      >
        <div className={styles.main}>
          <div className={styles.form}>
            {loading ? (
              <Loader />
            ) : (
              <UnavailabilityCreationForm
                reasons={unavailabilityReasons}
                formData={formData}
                accountResource={account.resource}
                error={error}
                editForm={setFormData}
              />
            )}
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("unavailability.creation.cancel")}
          </Button>
          <Button type="submit" status={isRequestPending ? "pending" : "none"}>
            {t("unavailability.creation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { UnavailabilityCreation };
